export enum ScoreCard {
    SingleCongressionalDistrict = 0,
    MultiCongressionalDistrict,
    SingleCongressman
}
